<div [class]="'column fill-vertical-horizontal menu-wrapper menu-wrapper-' + mode">
  <div class="navigation-top-row">
    <a class="logo-img" [routerLink]="'/'">
      <img [src]="currentCustomer.logoUrlBase + 'sidebar-logo.svg'" />
    </a>
  </div>
  <div class="column grow">
    <app-navigation-item
      *ngFor="let item of menuItems"
      [hidden]="!item.showOnSideBar"
      [link]="item.path"
      [text]="item.text"
      [icon]="item.icon"
      [direction]="menuItemsDirection"
      [mode]="mode"
      [extra]="item.extra"
      [active]="item.active"
      (clickCallback)="item.click ? item.click() : null"
    >
    </app-navigation-item>
  </div>

  <div>
    <div class="column">
      <app-navigation-item
        *ngFor="let item of bottomMenuItems"
        [hidden]="!item.showOnSideBar"
        [link]="item.path"
        [text]="item.text"
        [icon]="item.icon"
        [direction]="menuItemsDirection"
        [mode]="mode"
        [extra]="item.extra"
        [active]="item.active"
        (clickCallback)="item.click ? item.click() : null"
      >
      </app-navigation-item>
    </div>

    <div class="column">
      <app-navigation-item
        (click)="logout()"
        text="{{ 'NavigationComponent.logout' | translate }} "
        icon="log-out-outline"
        [direction]="menuItemsDirection"
        [mode]="mode"
      >
      </app-navigation-item>
    </div>
  </div>
</div>
